<template>
</template>

<script>

export default {
	name: "report_doc_delete",
	props: {
		linkMenu: {
			type: String,
			required: false,
			default: '/zvity-pro-robotu/workreports?doc_type=0'
		}
	},
	components: {},
	data() {
		return {}
	},
	created() {
		EventBus.$on('delete_report_doc', this.questionDeleteReport);
	},
	beforeUnmount() {
		EventBus.$off('delete_report_doc', this.questionDeleteReport);
	},
	methods: {
		async questionDeleteReport(docId) {
			const isOk = confirm_imc('Видалити вибраний документ ?');
			try {
				await isOk;
				try {
					await axios.post('/index.php?option=com_imc_report&task=doc.delete_doc&format=json',
						{
							docId: docId
						},
						{
							headers: {"Content-Type": "application/json"}
						})
						.then(({data}) => {
							if (data?.status === "operation_fail") {
								EventBus.$emit('show_toast', {
									err: data?.message,
									type: "danger",
									title: 'Помилка видалення звіту'
								});
								return;
							}
							// window.location.href = this.linkMenu;
						})
						.catch(err => {
							const message = err?.response?.data?.message ?? null;
							if (message) {
								EventBus.$emit('show_toast', {err: message, type: "danger", title: 'Помилка видалення звіту'});
							} else {
								EventBus.$emit('show_toast', {err: '', type: "danger", title: 'Помилка видалення звіту'});
							}
						})
				} catch (err) {

				}
			} catch (err) {
			}
		},
	},

	computed: {}
}
</script>
